var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 13.583l-9-6.5c0-.299.11-.554.33-.766.22-.211.484-.317.795-.317h15.75c.31 0 .576.106.795.317.22.212.33.467.33.766l-9 6.5zm0 1.947l9-6.5v8.887c0 .299-.11.554-.33.766-.22.211-.484.317-.795.317H4.125c-.31 0-.576-.106-.795-.317a1.025 1.025 0 0 1-.33-.766V9.03l9 6.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.873890c6c1c7a7136f7ad89d326f7e81.svg";
export { ForwardRef as ReactComponent };